import { jsx as _jsx } from "react/jsx-runtime";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import CustomApplicationInsights from './CustomAppInsights';
import { AnalyticsContext } from './AnalyticsContext';
/**
 * Provider to configure MSRC's preconfigured app insights instance.
 */
export const AnalyticsProvider = ({ applicationInsightsKey, children, roleName, }) => {
    // Application Insights (via the "NPM Setup")
    // https://github.com/microsoft/ApplicationInsights-JS#npm-setup-ignore-if-using-snippet-setup
    let appInsights;
    let reactPlugin = undefined;
    if (applicationInsightsKey) {
        const browserHistory = createBrowserHistory();
        reactPlugin = new ReactPlugin();
        const localAppInsights = new ApplicationInsights({
            config: {
                enableAutoRouteTracking: true,
                instrumentationKey: applicationInsightsKey,
                extensions: [reactPlugin],
                extensionConfig: {
                    [reactPlugin.identifier]: { history: browserHistory },
                },
            },
        });
        localAppInsights.loadAppInsights();
        // Initial manual call to `trackPageView` to establish the current user/session/pageview
        localAppInsights.trackPageView();
        if (roleName) {
            //https://docs.microsoft.com/en-us/azure/azure-monitor/app/app-map?tabs=javascript#set-or-override-cloud-role-name
            localAppInsights.addTelemetryInitializer(telemetryItem => {
                if (!telemetryItem.tags) {
                    telemetryItem.tags = [];
                }
                telemetryItem.tags['ai.cloud.role'] = roleName;
                telemetryItem.tags['ai.cloud.roleInstance'] = roleName;
            });
        }
        appInsights = new CustomApplicationInsights(localAppInsights);
    }
    return (_jsx(AnalyticsContext.Provider, { value: { appInsights, reactPlugin }, children: children }));
};
